<div class="profile-photo" *ngIf="available !== false">
  <span class="shot" [style.--hue]="hue">
    <img *ngIf="photo; else letters" [src]="photo" alt="Your profile photo" />
    <ng-template #letters><span class="initials">{{ initials }}</span></ng-template>
  </span>
  <div class="text">
    <strong>Profile photo</strong>
    <!--  <p class="hint">Shown beside your name in chat, here and in MedicAI Connect. Without one, your initials are used.</p> -->
    <div class="actions">
      <input #picker type="file" accept="image/png,image/jpeg,image/webp" hidden (change)="pick(picker)" />
      <button mat-stroked-button type="button" (click)="picker.click()" [disabled]="busy">
        <mat-icon>photo_camera</mat-icon>{{ photo ? 'Change photo' : 'Add a photo' }}
      </button>
      <button mat-button type="button" color="warn" *ngIf="photo" (click)="remove()" [disabled]="busy">Remove</button>
      <mat-spinner diameter="18" *ngIf="busy"></mat-spinner>
    </div>
  </div>
</div>